import es from './translation'
import { ReturnStatus } from "@/types/enum/notification";
import { ISSUE_TYPE } from "@/types/enum/general";

//Write here all the changes to translations that are not correct
es.object.message = 'mensaje | mensajes'
es.messages.dashboard.home.orders = 'últimas órdenes'
es.messages.order.currentOrders = 'últimas órdenes'
es.label.day = 'Día'
es.messages.cart.amountItems = "{amount} artículo único"
es.messages.cart.amount = "{amount} Posiciones del artículo"
es.title = 'Octopus'
es.placeholder.location.name = 'Nombre de tu ubicación'
es.label.reducedListDesignDescription = 'El diseño de lista reducida cambia la vista de tu lista. Las imágenes de los productos están ocultas, pero se muestran botones adicionales para tu manejo.'
es.messages.noPromotion = 'Lo sentimos, no tenemos ninguna promoción para tú en este momento.'
es.messages.cart.amount = '{amount} N° total de artículos'
es.messages.cart.amountItems = '{amount} N° de productos'
es.object.article = 'N° de artículos'
es.success.addCartNumber = '{target} Número total de artículos de {traget2} Número de artículos que se han añadido a la cesta.'
es.label.octopusId = 'Octopus ID'
es.messages.setting.welcome3 = 'qué modo de visualización prefieres'
es.object.display = 'Opciones modo de visualización'
es.titleRoute.settingDisplay = 'Opciones modo de visualización'
es.titleRoute.orderNotificationTimer = 'Recordatorio de pedido'
es.object.promotion = 'Promoción | Promociones'
es.error.returnType[ReturnStatus.LIST_ALREADY_IN_CART] = 'La lista ya está en la cesta de la compra, edita tu selección en la cesta de la compra. La lista sólo se puedes editar una vez que se ha ordenado en la cesta de la compra.'
es.error.returnType[ReturnStatus.LIST_CANT_BE_DELETED] = 'No se puedes borrar la lista.'
es.error.returnType[ReturnStatus.OWNER_CANT_BE_EDITED] = 'El propietario no puedes editar'
es.messages.card.createLocationExplanation = 'Un local puedes ser un bar, un restaurante, un hotel, una oficina o un negocio similar.'
es.placeholder[ISSUE_TYPE.BUG].steps = '¿Qué medidas se tomaron hasta que se produjo el fallo? / ¿Cómo se puedes reproducir el fallo?'
export default es
